import type React from "react";

interface DirectoryLetterHeadingProps {
  readonly letter: string;
}

// Never make this sticky: the rail jumps by the heading's delta from the
// scroller, and a stuck heading's delta is zero, so the jump would do nothing.
export function DirectoryLetterHeading({
  letter,
}: DirectoryLetterHeadingProps): React.JSX.Element {
  return (
    <div
      data-directory-letter={letter}
      data-testid={`directory-letter-heading-${letter}`}
      className="pt-4 pb-1 text-pds-2xs font-semibold text-muted-foreground"
    >
      {letter}
    </div>
  );
}
